import { getActivePinia } from 'pinia'
import { useLeadsStore } from './leadsStore'
import { useChatStore } from './chatStore'
import { useContactsStore } from './contactsStore'
import { permissionStore } from './permissions'
import { useNotificationsStore } from './notifications'
import { usePlanStore } from './plan'
import { useReportsStore } from './reportsStore'
import { useAgendaStore } from './agendaStore'
import { disconnectAllWebSockets, clearWebSocketCaches } from '@/services/websocketUtils'

export async function clearAllStores() {
  const pinia = getActivePinia()
  if (!pinia) return

  // 0. Disconnect all WebSockets and clear module-level caches
  disconnectAllWebSockets()
  clearWebSocketCaches()

  // 1. Call $reset() on all stores that support it
  const leadsStore = useLeadsStore()
  const chatStore = useChatStore()
  const contactsStore = useContactsStore()
  const permStore = permissionStore()
  const notificationsStore = useNotificationsStore()
  const planStore = usePlanStore()
  const reportsStore = useReportsStore()
  const agendaStore = useAgendaStore()

  leadsStore.$reset()
  chatStore.$reset()
  contactsStore.$reset()
  permStore.$reset()
  notificationsStore.$reset()
  planStore.$reset()
  reportsStore.$reset()
  agendaStore.$reset()

  // 2. Call custom clearData() if implemented
  if (typeof (leadsStore as any).clearData === 'function') (leadsStore as any).clearData()
  if (typeof (chatStore as any).clearData === 'function') (chatStore as any).clearData()
  if (typeof (contactsStore as any).clearData === 'function') (contactsStore as any).clearData()
  if (typeof (planStore as any).clearPlan === 'function') (planStore as any).clearPlan()

  console.log('🧹 All domain stores have been reset')
}
